// this file is automatically generated by git.version.ts script
export const versions = {commit: 'dfd09f1f', tag: '2026.2.002-RELEASE'};
